import * as Common from "../../commons/common"

export class BaseSheet {
  id: number
  sheet_code: string
  report_no: number
  publish_at: string
  std_deadline_at: string
  final_deadline_at: string
  answer_image_completed: boolean
  is_published: boolean

  constructor(x: any){
    this.id = x.id;
    this.sheet_code = x.sheet_code;
    this.report_no = x.report_no;
    this.publish_at = x.publish_at;
    this.std_deadline_at = x.std_deadline_at;
    this.final_deadline_at = x.final_deadline_at;
    this.answer_image_completed = x.answer_image_completed;
    this.is_published = x.is_published;
  }
}

export class StudentSubject {
  subject_code: string
  nendo: number
  report_count: number
  subject_name: string
  
  constructor(x: any){
    this.subject_code = x.subject_code;
    this.nendo = x.nendo;
    this.report_count = x.report_count;
    this.subject_name = x.subject_name;
  }
}

export class StudentSheet {
  id: number
  base_sheet_id: number = null
  times: number = null
  status: number = null
  score: number = null
  submitted_at: string = null

  constructor(x: any){
    if(x){
      this.id = x.id;
      this.base_sheet_id = x.base_sheet_id;
      this.times = x.times;
      this.status = x.status;
      this.score = x.score;
      this.submitted_at = this.status > Common.StudentSheetStatusEnum.Answering ? `${Common.formatDate(x.submitted_at, 'Y年M月D日')} 提出` : "";
    }
  }
}

export class StudentSubjectRow {
  studentSubject: StudentSubject
  studentSheets: StudentSheet[]
  baseSheets: any[]
  examStudentSheets: StudentSheet[]
  examBaseSheets: any[]
  supplementaryExamStudentSheets: StudentSheet[]
  supplementaryExamBaseSheets: any[]
  passed_counts: number[]
  passedStudentSheets: StudentSheet[][]
  isAnswerTargets: boolean[]
  isDisp: boolean = false
  isCorrectImagePreviews: boolean[]

  constructor(x: any){
    this.studentSubject = new StudentSubject(x.student_subject);
    this.studentSheets = x.student_sheets.map((y: any) => y ? new StudentSheet(y) : null);
    this.baseSheets = x.base_sheets.map((y: any) => y ? new BaseSheet(y) : null);
    // 旧APIレスポンスでもレポート一覧を表示できるよう、新設配列は空配列として扱う
    this.examStudentSheets = (x.exam_student_sheets || []).map((y: any) => y ? new StudentSheet(y) : null);
    this.examBaseSheets = (x.exam_base_sheets || []).map((y: any) => y ? new BaseSheet(y) : null);
    this.supplementaryExamStudentSheets = (x.supplementary_exam_student_sheets || []).map((y: any) => y ? new StudentSheet(y) : null);
    this.supplementaryExamBaseSheets = (x.supplementary_exam_base_sheets || []).map((y: any) => y ? new BaseSheet(y) : null);
    this.passed_counts = x.passed_counts;
    this.passedStudentSheets = x.passed_student_sheets;
    this.isAnswerTargets = x.is_answer_targets;
    this.isCorrectImagePreviews = x.is_correct_image_previews;
  }
}
